import { Component, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { UtilsService } from '../shared/utils-service';


@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {

	private searchurl: string = this.utils.url+"/ddmfCustomerEnquiry/searchCustomer";
	private searchUsers: any = [];
	private searchData: any = [];
	private individual : boolean;
	private search : boolean;
	SearchInput: string;
	searchUser: any = {};
	private searchMember: any=[];
	private customerDetail: any = [];
  	constructor( private http: Http, private utils: UtilsService) {
  	this.individual=false; 
  	this.search=false;
  	 /*this.getData().subscribe(data => {
    this.searchUsers = data['_body'];
    this.searchUsers = JSON.parse(this.searchUsers);
});*/
    }

  	ngOnInit() {
  	}
  	
  	getData() {
    return this.http.get(this.searchurl);
  }
  
  
  customer($event, detail)
  {
  this.customerDetail=detail;
  }
    searchCustomer(){
    	//console.log(this.searchUser);
  		var headers = new Headers();
		headers.append('Content-Type', 'application/json');								
     
   		this.http.post(this.searchurl,JSON.stringify({
   		
   			 	
					"subjectType":this.searchUser.subjectType,
					"searchBy":this.searchUser.searchBy,
					"searchInput":this.searchUser.searchInput,
					"userId":"tcs_uat"
  }), { headers: headers }).subscribe(res => {
   				 //console.log(res);
   				 let result = JSON.parse(res['_body']);
   				 this.searchData = result['ddmfSearchCustomerList'];
   
});   
  }

}



// WEBPACK FOOTER //
// ./src/app/customer/customer.component.ts